<div class="no-data-wrapper">
  <div class="no-data-container">
    <img src="../../../assets/icons/no-data.png" class="no-data-illustration" />
    <p class="no-data-heading">{{ 'ui_no_lbl' | translate }} {{ item }} {{ 'ui_found_lbl' | translate }}!</p>
  </div>
</div>
